import { TypedDocumentNode } from '@apollo/client';
import { Severity } from '@treyd-io/core/constants/logging';
import { REQUEST_METHOD } from '@treyd-io/core/constants/request';
import request from '@treyd-io/core/utils/request';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getServerSession } from 'next-auth';
import { getSession, signOut } from 'next-auth/react';

export { request };

export async function log<ResponseDataType>({
  res,
  options,
  severity,
}: {
  res: AxiosResponse<ResponseDataType>;
  options?: AxiosRequestConfig;
  severity?: Severity;
}) {
  const isServerEnvironment = typeof window === 'undefined';
  const session = isServerEnvironment
    ? await getServerSession()
    : await getSession();

  if (session?.error) await signOut();

  return axios.request<ResponseDataType>({
    baseURL: '/api',
    url: '/log',
    method: REQUEST_METHOD.POST,
    data: {
      ...res,
      additionalData: {
        severity,
        correlationId: session?.correlationId,
        userId: session?.user?.id,
        companyId: session?.user?.company_id,
      },
    },
    ...options,
  });
}

export function proxy<TResult, TVariables = Record<string, unknown>>(data: {
  query?: TypedDocumentNode<TResult, TVariables>;
  mutation?: TypedDocumentNode<TResult, TVariables>;
  variables?: TVariables;
}) {
  return request<TResult>({
    baseURL: '/api/graphql',
    url: '/proxy',
    method: REQUEST_METHOD.POST,
    data,
    headers: {
      noAuth: 'true',
    },
  });
}
